export default __webpack_public_path__ + "static/media/desenvolvidoPorFin-tracks.5077fb2e.svg";